"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aeJson = void 0;
exports.aeJson = {
    EntityId: '1508923396601_22997',
    Id: 33891159500,
    ArtNr: { DE: '3150.1PZ.A3' },
    ArtNrExists: true,
    ArtNrGenerated: '3150.1PZ.A3.X46',
    Bezeichnung: { 'de-DE': 'Kunststoff, starr, ohne Kamm', 'en-GB': 'Plastic, locking, without tiewrap plate' },
    KetteRef: [
        3439, 3440, 3441, 3442, 3443, 3444, 3445, 3749, 3750, 3751, 3752, 3753, 3754, 3755, 4814, 4815, 4816, 4817, 4818,
        4819, 4820, 4906, 4935, 4936, 4937, 4938, 5017, 5018, 5019, 5020, 5021, 5022, 5023, 46456, 46462, 46463, 46464,
        46465, 59527, 59537, 68064, 68074,
    ],
    Laenge: { Unit: 'mm', Value: 60 },
    Montiert: true,
    Befestigungsvariante: 'A3',
    Gewicht: { Unit: 'kg', Value: 0.100639999389648 },
    Color: '0',
    Material: '0',
    AufbauId: 1,
    FestpunktGerade: false,
    FestpunktUngerade: false,
    KomplettsatzGerade: false,
    KomplettsatzUngerade: false,
    MitnehmerGerade: true,
    MitnehmerUngerade: true,
    ZugentlastungTyp: 'Ohne_Kamm',
    Zweiteilig: false,
    Application: 1,
    Festpunkt: false,
    GliedAnzahlAbhaengig: 0,
    Komplettsatz: false,
    Mitnehmer: true,
    ZubehoerRef: [],
};
//# sourceMappingURL=aeJson.js.map